import React, { FC } from 'react';

const AuthErrorPage: FC = () => {
  const params = new URLSearchParams(location.search);
  const errorCode = params.get('code');

  return (
    <div
      style={{
        minHeight: '100vh',
        backgroundColor: '#301d4c',
        backgroundImage: 'radial-gradient(49% 117%, #2b1c42 0, #150c21 100%)',
        fontFamily: 'proxima-nova-n4,proxima-nova,Helvetica,arial,sans-serif',
        display: 'flex',
        flexDirection: 'column',
      }}
    >
      <div style={{ flex: 1, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
        <div
          style={{
            background: '#fff',
            border: '1px solid #ede6f7',
            borderRadius: 12,
            padding: '2.5em 2em',
            maxWidth: 480,
            width: '100%',
            boxShadow: '0 4px 24px rgba(48,29,76,0.08)',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            position: 'relative',
          }}
        >
          <img
            src="https://static.findmyupgrade.com/website/logo-mastermind.svg"
            alt="mastermind logo"
            style={{
              height: 48,
              maxWidth: 220,
              display: 'block',
              marginBottom: '2em',
              marginTop: '-1em',
            }}
          />
          <h1
            style={{
              color: '#301d4c',
              fontSize: '2em',
              marginBottom: '0.5em',
              fontWeight: 700,
              textAlign: 'center',
            }}
          >
            Authentication Error
          </h1>
          <div
            style={{
              marginTop: '1em',
              color: '#331c54',
              width: '100%',
              textAlign: 'center',
            }}
          >
            We are unable to authorize access. Please check your username and password and be sure you are in your authorized location.
          </div>
          <p
            style={{
              marginTop: '1.5em',
              color: '#301d4c',
              textAlign: 'center',
            }}
          >
            If you believe you reached this in error,<br /> please contact support at{' '}
            <a href="tel:+18008010018" style={{ color: '#301d4c', textDecoration: 'underline' }}>
              1-800-801-0018
            </a>
          </p>
          <div style={{ display: 'flex', justifyContent: 'center', width: '100%' }}>
            <a
              href="/"
              style={{
                display: 'inline-block',
                marginTop: '1em',
                color: '#331c54',
                background: '#f78e20',
                fontWeight: 600,
                padding: '0.75em 2em',
                borderRadius: 6,
                textDecoration: 'none',
                textAlign: 'center',
                transition: 'background 0.2s',
              }}
              onMouseOver={e => ((e.currentTarget.style.background = '#e67600'))}
              onMouseOut={e => ((e.currentTarget.style.background = '#f78e20'))}
              onFocus={e => (e.currentTarget.style.background = '#e67600')}
              onBlur={e => (e.currentTarget.style.background = '#f78e20')}
            >
              Return to Home
            </a>
          </div>
          {errorCode && (
            <div
              style={{
                marginTop: '2em',
                color: '#888',
                fontSize: '1em',
                textAlign: 'center',
                wordBreak: 'break-all',
              }}
            >
              Error code: <span style={{ fontFamily: 'monospace' }}>{errorCode}</span>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default AuthErrorPage;
